.root {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    padding: 8px;

    background-image: url("/img/background/mobile-blueprint.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    display: flex;
    justify-content: center;
    align-items: center;
}

@supports (background-image: url("/img/background/mobile-blueprint.webp")) {
    .root {
        background-image: url("/img/background/mobile-blueprint.webp");
    }
}

@media (min-width: 900px) {
    .root {
        background-image: url("/img/background/desktop-blueprint.jpg");
    }

    @supports (background-image: url("/img/background/desktop-blueprint.webp")) {
        .root {
            background-image: url("/img/background/desktop-blueprint.webp");
        }
    }
}

.systemAlert {
    width: 500px;
    max-width: 100%;
}

.paper {
    width: 500px;
    max-width: 100%;
    padding: 16px 32px;
    opacity: 0.9;
}

.paperContainer {
    max-width: 100%;
}

.paper form {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    row-gap: 16px;
}
